import { feedback } from './feedback';
import { checkboxCustom } from './checkbox';

export function modals() {

    setTimeout( function() {
        const request = new XMLHttpRequest();
        const url = '/ajax_get_modals';
        request.open('GET', url);

        request.addEventListener('readystatechange', () => {
            if (request.readyState === 4 && request.status === 200) {
                const r = (function(text) {
                    try {
                        return JSON.parse(text);
                    } catch (e) {
                        return {}
                    }
                })(request.responseText);
                // Если статус ок
                if (r.status == 'ok') {

                    const modalWrapper = document.createElement('div');
                    modalWrapper.innerHTML = r.data;
                    document.body.append(modalWrapper);

                    let modalOpen = document.querySelectorAll('[data-open]');

                    modalOpen.forEach( function(item) {
                        item.addEventListener('click', function() {
                            let name = item.dataset.open,
                                modalWindow = document.querySelector(`[data-modal="${name}"]`);

                            document.body.style.overflow = 'hidden';
                            document.documentElement.style.overflow = 'hidden';

                            modalWindow.classList.add('is-active');

                            modalWindow.addEventListener('click', function(event) {
                                if (event.target.hasAttribute('data-modal-close')) {
                                    document.body.style.overflow = '';
                                    document.documentElement.style.overflow = '';

                                    modalWindow.classList.remove('is-active');
                                }
                            });
                        });
                    });

                    feedback();
                    checkboxCustom();
                }
            }
        });
        request.send();

    },1000)
}
